import React from 'react';
import { Grid, Box } from '@mui/material';
import InfoCard from '../../../components/dashboard';
import { UserApi } from '../../../apis';

function Dashboard() {
    const [data, setData] = React.useState([]);

    // Define data structure with keys that match API response keys
    let dataTitle = [
        {
            title: 'Assigned Projects',
            icon: 'DashboardIcon',
            key: 'projects', // Match the API key here
            number: 0
        },
        {
            title: 'Time Spent this week',
            icon: 'DashboardIcon',
            key: 'weekTime', // This already matches the API response
            number: 0
        },
        {
            title: 'Total Time',
            icon: 'DashboardIcon',
            key: 'totalTime', // This already matches the API response
            number: 0
        },
    ];

    React.useEffect(() => {
        UserApi.getUserDashboardData().then((res) => {
            // Map the response data to the dataTitle array based on the keys
            const newData = dataTitle.map((item) => {
                return {
                    ...item,
                    number: res.data.data[item.key] || item.number
                };
            });

            setData(newData);
        });
    }, []);

    return (
        <InfoCard data={data} />
    );
}

export default Dashboard;
